import { secondsToFormattedLabel } from '../../utils/date';

export default function ModalUsageSummary(
  Account,
  $uibModalInstance,
  $filter,
  toaster,
  subscriptionItemId,
  plan,
  periodStart,
  periodEnd
) {
  'ngInject';

  this.subscriptionItemId = subscriptionItemId;
  this.plan = plan;
  this.periodStart = periodStart;
  this.periodEnd = periodEnd;
  this.usageType = plan.metadata.usage_type;

  this.summaries = Account.getUsageSummaries({
    stripe_subscription_item_id: this.subscriptionItemId,
    subscription_period_start: periodStart,
  });
  this.loadingPromises = [this.summaries.$promise];

  this.loading = true;
  this.summaries.$promise
    .then((r) => {
      if (r.length > 0) {
        this.summary = r[0];
        _.forEach(this.summary.records, (record) => {
          switch (this.summary.type) {
            case 'broadcast_duration':
            case 'captioning':
              record.duration = secondsToFormattedLabel(record.qty);
              break;
            case 'viewership':
              record.duration = $filter('number')(Math.round(record.qty / 60));
          }
        });
      }
      this.loading = false;
    })
    .catch((err) => {
      toaster.pop(
        'warning',
        'Unable to load usage summary. Please refresh the page and try again.'
      );
      console.error(err);
      this.loading = false;
    });

  this.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-usage-summary.js